import { render, staticRenderFns } from "./restore-case-modal.vue?vue&type=template&id=6dc547e2&"
import script from "./restore-case-modal.vue?vue&type=script&lang=js&"
export * from "./restore-case-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports